import {baseApi} from "../api/axios";
import {useEffect, useState} from "react";
import LoadingComponent from "../components/Loading/LoadingComponent";
import NoImage from '../assets/images/no-image.png'
export default function NotificationsPage(){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [notifications, setNotifications] = useState([])
    const [nextPage, setNextPage] = useState(null)
    const [prevPage, setPrevPage] = useState(null)
    const getNotifications =async () => {
        setLoading(true)
        try {
            const response = await baseApi(`/notifications?page=${page}`)
            if (response && response.data) {
                setNotifications(response.data.notifications)
                setNextPage(response.data.next)
                setPrevPage(response.data.back)
            }
        } catch (e) {
            console.log('ERROR', e.response)
        }
        setLoading(false)
    }
    const nextPageNum = () => {
        setPage(page + 1)
    }
    const prevPageNum = () => {
        if (page > 1) {
            setPage(page - 1)
        }

    }
    useEffect(() => {
        getNotifications();
    }, [page]);
    if(loading){
        return <div id={'mainSlider'} className={'container'}>
            <div className="row justify-content-center">
                <div className="col-md-6 col-4">
                    <LoadingComponent/>
                </div>
            </div>
        </div>
    }
    if(!loading && notifications.length==0){
        return <div className={'container'}>
            <div className="row justify-content-center">
                <div className="col-6">
                    <div className="alert alert-danger">لا يوجد إشعارات</div>
                </div>
            </div>
        </div>
    }
    if(!loading && notifications.length>0){
          return <div className={'container'}>
            <div className="row justify-content-center">
                {notifications.filter((el)=>el.is_admin!==true).map((el,index)=>{
                return  <div className="col-md-8" key={index}>
                    <div className="rounded bg-white my-2 overflow-hidden">

                       <div className="d-flex gap-3 justify-content-start align-items-center">
                           <div className={'notification-img p-0 m-0'} style={{backgroundImage:`url(${el.img==''?NoImage:el.img})`}}></div>

                           <div className={'d-flex justify-content-start align-items-center detail-notification'}>
                               {el.status=='success'?<i className={'fa fa-circle-check text-success fa-1x mx-2'}/>:null}
                               {el.status=='error'?<i className={'fa fa-cancel text-danger fa-1x mx-2'}/>:null}
                               {el.status=='default'?<i className={'fa fa-bell text-warning fa-1x mx-2'}/>:null}
                               <div className="d-flex flex-column">
                                   <h5>{el.title}</h5>
                                   <p>{el.body} {el.is_admin}</p>
                                   <span className={'text-muted fs-6'}>{el.createdAt}</span>
                               </div>
                           </div>

                       </div>
                    </div>
                </div>

                })}
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-8 text-center">
                            <div className="d-flex justify-content-between gap-2">
                                {prevPage!==null? <button onClick={prevPageNum} className="btn-sm submit-btn">التالي</button>:null}
                                {nextPage!==null? <button onClick={nextPageNum} className="btn-sm submit-btn mx-1">السابق</button>:null}
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}